import { create } from "zustand";
import type { GridPos } from "@reagent/sim";

/** How the card being dragged wants to be aimed — mirrors cardViews.CardTarget. */
export type DragTarget = "tile" | "node" | "pipe" | "instant";

interface InteractionState {
  hoveredTile: GridPos | null;
  /** Set while dragging a hardware card; picks which placement ghost to draw. */
  draggedCardKind: string | null;
  /**
   * What the dragged card targets. The ghost has to know: a solid block over
   * the tile is right for hardware that occupies it, and actively misleading
   * for an attachment, which snaps onto the machine already standing there.
   */
  draggedCardTarget: DragTarget | null;
  setHoveredTile: (tile: GridPos | null) => void;
  setDraggedCard: (kind: string | null, target: DragTarget | null) => void;
}

export const useInteractionStore = create<InteractionState>((set) => ({
  hoveredTile: null,
  draggedCardKind: null,
  draggedCardTarget: null,
  setHoveredTile: (tile) => set({ hoveredTile: tile }),
  setDraggedCard: (kind, target) => set({ draggedCardKind: kind, draggedCardTarget: target }),
}));
